import {createReducer, createActions} from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */
const {Types, Creators} = createActions({
  chartPerformanceRequest: ['id', 'chart_type', 'period'],
  chartPerformanceSuccess: ['performanceResult'],

  chartStatusRequest: ['id', 'period'],
  chartStatusSuccess: ['statusResult'],

  chartsReset: null,
  chartsFetchingReset: null,
})

export const ChartsTypes = Types
export default Creators

/* ------------- Initial State ------------- */
export const INITIAL_STATE = Immutable({
  performanceResult: null,
  performanceFetching: false,

  statusResult: null,
  statusFetching: false,
})

/* ------------- Selectors ------------- */
export const ChartsSelectors = {
  getState: state => state.charts,
}

/* ------------- Reducers ------------- */

export const chartPerformanceRequest = (state, {id, chart_type, period}) => {
  return state.merge({performanceFetching: true})
}

export const chartPerformanceSuccess = (state, {performanceResult}) => {
  return state.merge({performanceFetching: false, performanceResult})
}

export const chartStatusRequest = (state, {id, period}) => {
  return state.merge({statusFetching: true})
}

export const chartStatusSuccess = (state, {statusResult}) => {
  return state.merge({statusFetching: false, statusResult})
}

export const chartsReset = state => {
  return INITIAL_STATE
}

export const chartsFetchingReset = state => {
  return state.merge({performanceFetching: false, statusFetching: false})
}

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.CHART_PERFORMANCE_REQUEST]: chartPerformanceRequest,
  [Types.CHART_PERFORMANCE_SUCCESS]: chartPerformanceSuccess,

  [Types.CHART_STATUS_REQUEST]: chartStatusRequest,
  [Types.CHART_STATUS_SUCCESS]: chartStatusSuccess,

  [Types.CHARTS_RESET]: chartsReset,
  [Types.CHARTS_FETCHING_RESET]: chartsFetchingReset,
})
